import * as fromDatatype from "../datatype-library/index";

export interface bl_del_logistic_hub_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    from_hub_guid: fromDatatype.GuidDataFieldInterface;
    to_hub_guid: fromDatatype.GuidDataFieldInterface;
    from_hub_lat: fromDatatype.NumericDatatypeInterface;
    from_hub_lng: fromDatatype.NumericDatatypeInterface;
    to_hub_lat: fromDatatype.NumericDatatypeInterface;
    to_hub_lng: fromDatatype.NumericDatatypeInterface;
    distance_meter: fromDatatype.NumericDatatypeInterface;
    travel_cost: fromDatatype.NumericDatatypeInterface;
    travel_duration: fromDatatype.NumericDatatypeInterface;
    rate_per_kg_per_km: fromDatatype.NumericDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    from_hub_name: fromDatatype.VarcharDatatypeInterface;
    from_hub_code: fromDatatype.VarcharDatatypeInterface;
    to_hub_name: fromDatatype.VarcharDatatypeInterface;
    to_hub_code: fromDatatype.VarcharDatatypeInterface;
    travel_mode: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    status : fromDatatype.StatusDataFieldInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    acl_policy : fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_del_logistic_hub_link_RowClass
implements bl_del_logistic_hub_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    from_hub_guid: fromDatatype.GuidDataFieldInterface;
    to_hub_guid: fromDatatype.GuidDataFieldInterface;
    from_hub_lat: fromDatatype.NumericDatatypeInterface;
    from_hub_lng: fromDatatype.NumericDatatypeInterface;
    to_hub_lat: fromDatatype.NumericDatatypeInterface;
    to_hub_lng: fromDatatype.NumericDatatypeInterface;
    distance_meter: fromDatatype.NumericDatatypeInterface;
    travel_cost: fromDatatype.NumericDatatypeInterface;
    travel_duration: fromDatatype.NumericDatatypeInterface;
    rate_per_kg_per_km: fromDatatype.NumericDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    from_hub_name: fromDatatype.VarcharDatatypeInterface;
    from_hub_code: fromDatatype.VarcharDatatypeInterface;
    to_hub_name: fromDatatype.VarcharDatatypeInterface;
    to_hub_code: fromDatatype.VarcharDatatypeInterface;
    travel_mode: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    status : fromDatatype.StatusDataFieldInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    acl_policy : fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}